jQuery(document).ready(function(){
if ( $(window).width() >= 1200) {
      $('.product-slider-product-template').slick({
   infinite: true,
   slidesToShow: 4,
   slidesToScroll: 1,
   infinite: false,
   focusOnSelect: true,
   centerPadding: '0px',
   dots: false,
  
   draggable: true,
   autoplay:true,
   autoplaySpeed:1500,
    prevArrow: '.thumbnails-slider__prev--product-template',
    nextArrow: '.thumbnails-slider__next--product-template'
 });
  
} else if ($(window).width() >= 600) {
   $('.product-slider-product-template').slick({
   infinite: true,
   slidesToShow: 3,
   slidesToScroll: 1,
   infinite: false,
   focusOnSelect: true,
   centerPadding: '0px',
   dots: false,
  
   draggable: true,
   autoplay:true,
   autoplaySpeed:1500,
    prevArrow: '.thumbnails-slider__prev--product-template',
    nextArrow: '.thumbnails-slider__next--product-template'
 });
  
} else {
   $('.product-slider-product-template').slick({
   infinite: true,
   slidesToShow: 3,
   slidesToScroll: 1,
   infinite: false,
   arrows:false,
   focusOnSelect: true,
   centerPadding: '0px',
   dots: false,
   draggable: true,
   autoplay:true,
   autoplaySpeed:1500,
    prevArrow: '.thumbnails-slider__prev--product-template',
    nextArrow: '.thumbnails-slider__next--product-template'
 });
  
}

  
if ( $(window).width() >= 1200) {
      $('.feature-product-slider-product-template').slick({
   infinite: true,
   slidesToShow: 5,
   slidesToScroll: 1,
     arrows:false,
   infinite: false,
   focusOnSelect: true,
   centerPadding: '0px',
   dots: false,
  
   draggable: true,
   autoplay:true,
   autoplaySpeed:1500,
    prevArrow: '.thumbnails-slider__prev--feature-product',
    nextArrow: '.thumbnails-slider__next--feature-product'
 });
  
} else if ($(window).width() >= 600) {
   $('.feature-product-slider-product-template').slick({
   infinite: true,
   slidesToShow: 3,
   slidesToScroll: 1,
   infinite: false,
   focusOnSelect: true,
   centerPadding: '0px',
   dots: false,
  
   draggable: true,
   autoplay:true,
   autoplaySpeed:1500,
    prevArrow: '.thumbnails-slider__prev--feature-product',
    nextArrow: '.thumbnails-slider__next--feature-product'
 });
  
} else {
   $('.feature-product-slider-product-template').slick({
   infinite: true,
   slidesToShow: 1,
   slidesToScroll: 1,
   infinite: false,
    arrows:false,
   focusOnSelect: true,
   centerPadding: '0px',
   dots: false,
  
   draggable: true,
   autoplay:true,
   autoplaySpeed:1500,
    prevArrow: '.thumbnails-slider__prev--feature-product',
    nextArrow: '.thumbnails-slider__next--feature-product'
 });
  
}

/* top banner slider section */
 // slider
  $slick_slider = $('.top_slider');
  settings_slider = {
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: true
    // more settings
  }
  slick_on_mobile( $slick_slider, settings_slider);

// slick on mobile
  function slick_on_mobile(slider, settings){
    $(window).on('load resize', function() {
      if ($(window).width() > 767) {
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
        return
      }
      if (!slider.hasClass('slick-initialized')) {
        return slider.slick(settings);
      }
    });
  };


});
